/** Pure helpers for form field tree (add / edit form). */

export function generateRandomNumber() {
  return Math.floor(Math.random() * 1000000000);
}

export function removeElement(elements, id) {
  return elements.filter((item) => {
    if (item.id === id) {
      return false;
    } else if (item.elements) {
      item.elements = removeElement(item.elements, id);
      return true;
    } else {
      return true;
    }
  });
}

export function findElementAndParent(elements, childId, parent = null) {
  let result = { child: null, parent };
  elements.some((item) => {
    if (item.id === childId) {
      result = { child: item, parent };
      return true;
    } else if (item.elements) {
      const { child, parent: newParent } = findElementAndParent(
        item.elements,
        childId,
        item
      );
      if (child) {
        result = { child, parent: newParent };
        return true;
      }
    }
    return false;
  });
  return result;
}
